import { FormApiCategory } from '../models/form-api-category.model';

export function getCategoryById(id: number, categories: FormApiCategory[]): FormApiCategory {
    if (!id || !categories?.length) {
        return null;
    }

    const category = categories.find((cat) => {
        return cat.id === id;
    });

    if (category) {
        return category;
    } else {
        let categoriesChildren = [];

        categories.forEach((cat) => {
            categoriesChildren = categoriesChildren.concat(cat.children);
        });

        return getCategoryById(id, categoriesChildren);
    }
}
